module.exports = __webpack_public_path__ + "img/0fddd51.jpg";